import React, { useEffect, useRef } from 'react';
import 'twin.macro';

export const TwitterScript = {
  status: 'initial',
  script: undefined,
  twitIds: [],
};

const embedTwitter = (twitId, element) => {
  if (TwitterScript.status === 'loaded') {
    window.twttr.widgets.createVideo(twitId, element);
  } else {
    TwitterScript.twitIds.push([twitId, element]);
  }
  if (TwitterScript.status === 'initial') {
    TwitterScript.script = document.createElement('script');
    TwitterScript.script.src = 'https://platform.twitter.com/widgets.js';
    document.head.appendChild(TwitterScript.script);
    TwitterScript.status = 'loading';
    TwitterScript.script.onload = () => {
      TwitterScript.twitIds.forEach(([twitId, element]) =>
        window.twttr.widgets.createVideo(twitId, element),
      );
      TwitterScript.status = 'loaded';
      TwitterScript.twitIds = [];
      document.head.removeChild(TwitterScript.script);
    };
    TwitterScript.script.onerror = () => {
      const message = document.createElement('h2');
      const twitUrl = 'https://twitter.com/user/status/' + twitId;
      message.innerHTML =
        'Je maakt gebruikt van een plugin die deze embed blokkeert. ' +
        'Klik' +
        "<a href='" +
        twitUrl +
        '\' class="brand-link" target="_blank" rel="noopener noreferrer"> hier </a>' +
        'om het item te bekijken.';
      element.appendChild(message);
    };
  }
};

export const TwitterEmbed = ({ id }) => {
  const ref = useRef();

  useEffect(() => {
    embedTwitter(id, ref.current);
  }, [id]);

  return <div ref={ref} tw='w-full h-full flex justify-center items-center'></div>;
};
